import React from "react";
import { useField } from "formik";
import { pluralizeWithCount } from "@common/helpers/string";
import { Picker } from "@design-system/Picker/Picker.lib";
import styles from "./ConditionForm.module.scss";

const daysOptions = [
    { value: 1, label: pluralizeWithCount("day", 1) },
    { value: 2, label: pluralizeWithCount("day", 2) },
    { value: 3, label: pluralizeWithCount("day", 3) },
    { value: 4, label: pluralizeWithCount("day", 4) },
    { value: 5, label: pluralizeWithCount("day", 5) },
    { value: 6, label: pluralizeWithCount("day", 6) },
    { value: 7, label: pluralizeWithCount("day", 7) },
];

export const DateProximityConditionForm: React.FC = () => {
    const [dateProximityField, , dateProximityHelpers] = useField<number>(
        `conditions.dateProximity`,
    );

    return (
        <div className={styles.dateProximityConditionForm}>
            <span>Look for transactions within</span>
            <Picker.Select
                items={daysOptions}
                value={dateProximityField.value ?? null}
                onValueChange={(v) => {
                    if (v !== null) {
                        dateProximityHelpers.setValue(v);
                    }
                }}
                placeholder="Select days"
            />
        </div>
    );
};
